module.exports = __webpack_public_path__ + "img/news-sust-report.jpg?d2aeafae98bedc3c610956e0ebc9ed74";